import React, { ReactNode } from "react";

import classNames from "classnames";

import {CheckmarkIcon, MinusIcon} from "../icons";
import "./_style.module.scss";

interface FormCheckboxProps {
  id: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  label?: string | ReactNode;
  prefixLabelIcon?: React.ReactNode;
  suffixLabelIcon?: React.ReactNode;
  disabled?: boolean;
  showMinusIcon?: boolean;
  className?: string;
  tooltipContent?: string;
  tooltipPosition?:
    | "top"
    | "right"
    | "left"
    | "bottom"
    | "topLeft"
    | "topRight";
}

const FormCheckbox = (props: FormCheckboxProps) => {
  const {
    id,
    checked,
    onChange,
    label,
    prefixLabelIcon,
    suffixLabelIcon,
    disabled,
    showMinusIcon,
    className,
  } = props;
  const checkmarkSize =  12;
  const checkboxInputClass = classNames("checkboxInput", className, {
    "is-disabled": disabled,
  });
  const checkmarkClass = classNames("checkmark", {
    "is-disabled": disabled,
  });
  const checkboxLabelClass = classNames("checkbox-label-content", {
    "is-disabled": disabled,
  });

  return (
    <div className="custom-checkbox">
      <label htmlFor={id} className={checkmarkClass}>
        <span
          className={`checkbox-icon ${showMinusIcon ? "minus-icon" : "check-icon"} ${disabled ? "disabled" : ""}`}
        >
          {showMinusIcon ? (
            <MinusIcon size={checkmarkSize} />
          ) : checked ? (
            <CheckmarkIcon size={checkmarkSize} />
          ) : null}
        </span>
        <input
          type="checkbox"
          id={id}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
          className={checkboxInputClass}
        />
        <span className={checkboxLabelClass}>
          {prefixLabelIcon}
          {label}
          {suffixLabelIcon}
        </span>
      </label>
    </div>
  );
};

export default FormCheckbox;
